import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import VueCookies from 'vue-cookies'
import flatPickr from 'vue-flatpickr-component'
import VueToast from 'vue-toast-notification'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';
import Lingallery from 'lingallery'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import VueHtmlToPaper from 'vue-html-to-paper';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueThailandAddress from 'vue-thailand-address';
import 'vue-thailand-address/dist/vue-thailand-address.css';
import VueBarcode from 'vue-barcode';
import { StreamBarcodeReader } from "vue-barcode-reader";
import JsonExcel from 'vue-json-excel'

Vue.use(BootstrapVue)
Vue.component('apexchart', VueApexCharts)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(vco)
Vue.use(VueRouter)
Vue.use(VueFeather)
Vue.use(VueCookies)
Vue.use(flatPickr)
Vue.use(VueToast, {
  position: 'top',
})
Vue.use(VueSweetalert2)
Vue.component('lingallery', Lingallery)
Vue.component(VueNumberInput.name, VueNumberInput)
Vue.component('downloadExcel', JsonExcel)

const VTPoptions = {
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://fonts.googleapis.com/css2?family=Prompt:wght@300&display=swap',
    'https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/css/bootstrap.min.css'
  ],
}
Vue.use(VueHtmlToPaper, VTPoptions);
Vue.component('v-select', vSelect);
Vue.use(VueThailandAddress);
Vue.component('barcode',VueBarcode);
Vue.component('StreamBarcodeReader',StreamBarcodeReader);

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

// Uncomment this if you are having api served through other url or do not want to use fake backend
// Vue.prototype.$http = require('axios')
// Vue.prototype.$http.defaults.baseURL  = 'http://mock-api.coderthemes.com/'

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
